module.exports = __webpack_public_path__ + "img/base_hebergements_hebergement_groupe.68c1f7fa.svg";